export default {
  nfce: "NFCe",
  cfe: "CFe",
  receipt: "Recibo",
  order: "Ordem",
  devolution: "Devolução"
};



// WEBPACK FOOTER //
// ./src/core/enum/document-types.enum.js